import { EmojiUtils } from '@space-core/utils/emoji'

import { Icon } from './styles'
import type { EmojiProps } from './types'

function isValidImageURL(url: string) {
  return Boolean(url.match(/\w+\.(jpg|jpeg|gif|png|svg)$/gi))
}

export const Emoji = ({ id, className, size = '1rem' }: EmojiProps) => {
  const native = EmojiUtils.renderEmoji(id)

  if (native) {
    return <Icon className='_text-4'>{native}</Icon>
  }

  const unifiedToNative = EmojiUtils.getNativeFromUnified(id)

  if (unifiedToNative) {
    return <Icon className='_text-4'>{unifiedToNative}</Icon>
  }

  if (isValidImageURL(id)) {
    return <img src={id} alt='' />
  }

  return <em-emoji id={id} size={size} class={className}></em-emoji>
}
